import { SnapDirectSelect } from 'mapbox-gl-draw-snap-on-mode';

const DirectSelectMode = SnapDirectSelect;

const _ondrag = DirectSelectMode.onDrag;

DirectSelectMode.onDrag = function (state, e) {
  const isDraggingCoordinates =
    Array.isArray(state?.selectedCoordPaths) &&
    state.selectedCoordPaths.length > 0;

  // Block whole-feature translation while keeping vertex dragging enabled.
  if (!isDraggingCoordinates) {
    return;
  }

  const result = _ondrag?.apply(this, [state, e]);

  const feature = state.feature.toGeoJSON();

  this.map.fire('draw.liveUpdate', {
    features: [feature],
  });

  return result;
};

export default DirectSelectMode;
